export default __webpack_public_path__ + "90dd9bb3b2dab63d9a8409456bc9b9ad.png";